import React, { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { shopApi } from '~/src/shared/api/shopApi'

export function OrderPage() {
  const { number } = useParams()
  const [searchParams] = useSearchParams()
  const [order, setOrder] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const token = searchParams.get('token')
    shopApi.order(number, token)
      .then((response) => setOrder(response))
      .catch((err) => setError(err.message))
  }, [number, searchParams])

  if (error) return <p className="shop-error">{error}</p>
  if (!order) return <p>Cargando pedido...</p>

  return (
    <div className="shop-section narrow">
      <p className="shop-kicker">Pedido confirmado</p>
      <h1>{order.number}</h1>
      <p>Estado: {order.status}</p>
      <p>Sucursal asignada: {order.fulfillment_branch || 'Surtido desde multiples sucursales'}</p>
      <div className="cart-summary">
        <span>Total</span>
        <strong>${order.total_amount.toFixed(2)}</strong>
      </div>
      {order.items.map((item) => (
        <div key={item.id} className="cart-row compact">
          <span>{item.product_name} x {item.quantity}</span>
          <strong>${item.total_price.toFixed(2)}</strong>
        </div>
      ))}
    </div>
  )
}
